import Vue from "vue"
import App from "./App.vue"
import vuetify from "./plugins/vuetify"
import store from "@universidade-franciscana/componente-front/src/store"
import router from "./router/index"
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate"
import VueMask from "v-mask"
import ptBr from "vee-validate/dist/locale/pt_BR.json"
import * as rules from "vee-validate/dist/rules"
export const eventBus = new Vue()

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
localize("pt_BR", ptBr)
Vue.use(VueMask)
Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app")